import { render, staticRenderFns } from "./ExpirationModal.vue?vue&type=template&id=a2ff8914&"
import script from "./ExpirationModal.vue?vue&type=script&lang=js&"
export * from "./ExpirationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports